// extracted by css-extract-rspack-plugin
export default {"checkbox":"IT7UUCD7LSwM4M5J","checkbox_input":"QlQhoZLQEIAngen4","checkbox_span":"vFta4nDHKEXizLLM","loading":"eKQfKf2ppc8Y6lCI","loader-rotate":"FuWTggRFRcs8ZZvB"};